import { FC, memo } from 'react'
import { DropTargetMonitor, useDrop } from 'react-dnd'

export interface TargetBoxProps {
  canDrop?: Function
  onDrop: (item: any) => void
  types: string[]
  children: React.ReactNode
  className?: string
  highlightClassName?: string
}

export const TargetBox: FC<TargetBoxProps> = memo(function TargetBox({
  canDrop,
  onDrop,
  children,
  types,
  className = '',
  highlightClassName = 'outline-[5px] outline-red-400 outline-dashed z-9 relative',
}) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: types,
      drop(_item: any) {
        if (canDrop && !canDrop(_item)) return undefined
        onDrop(_item)
        return undefined
      },
      collect: (monitor: DropTargetMonitor) => ({
        isOver: monitor.isOver() && (!canDrop || canDrop(monitor.getItem())),
        canDrop: monitor.canDrop(),
      }),
    }),
    [onDrop],
  )

  return (
    <div
      ref={drop}
      className={[className, isOver ? highlightClassName : ''].filter(Boolean).join(' ')}
      role="TargetBox"
    >
      {children}
    </div>
  )
})
